import { EnvironmentContract } from '@environments/environment-contract';

export const environment: EnvironmentContract = {
    client: 'nwbw',
    production: true,
    environment: 'staging',
    enableDebugTools: false,
    apiUrl: 'https://staging.tool.wein-nachhaltig.de/api',   // For testing the pdf generator use 'http://host.docker.internal:8035/api'
    allowedJwtDomains: ['staging.tool.wein-nachhaltig.de',/^localhost/],
    markMeasureAsExcludedEnabled: true,
    sentryDsn: 'https://2a83078b9a814df08b7438fb44f71d11@sentry.webmozarts.com/9',
    sentryEnvironment: 'staging',
    sentryShowErrorDialog: false,
    sentryTracesSampleRate: 0.0,
    sentryRelease: 'nat-frontend@25.0',
    releaseVersion: 'chore/angular-22',
    releaseTimestamp: 1793371133,
    minExpressionValueShareDisplay: 0.01,
    enableRouterTracing: false,
    contactEmail: 'info@wein-nachhaltig.de',
    logo: 'logo.png',
    loginImg: null,
    requestImmutableBefore: new Date('2023-01-01'),
    locale: 'de',
};
